export default "__VITE_ASSET__DWhbuj22__"